/* VE SAV UI: drives the mobile product gallery progress line (see ve-sav-ui.css). */
(function () {
  function sync(counter) {
    var current = counter.querySelector('.slider-counter--current');
    var total = counter.querySelector('.slider-counter--total');
    if (!current || !total) return;
    var t = parseInt(total.textContent, 10) || 1;
    var i = (parseInt(current.textContent, 10) || 1) - 1;
    counter.style.setProperty('--vs-total', t);
    counter.style.setProperty('--vs-index', i);
    counter.dataset.vsTotal = t;
  }

  // Phones: start the collection sub-nav scrolled to the current collection
  function revealActiveCollection() {
    var menu = document.querySelector('ul.made-to-order-menu');
    if (!menu || menu.scrollWidth <= menu.clientWidth) return;
    var active = menu.querySelector('a.active');
    if (!active) return;
    var offset = active.getBoundingClientRect().left - menu.getBoundingClientRect().left;
    menu.scrollLeft += offset - 16;
  }

  // Size chart panels: the chart pages are typed in the page editor, each a little differently,
  // so every chart gets the same format here (styles in ve-sav-help.liquid):
  //  - the first header cell reads SIZE (blank, "SIZE (cm)" or "HAT SIZING CHART (cm)" before);
  //    a second table for leg length ("LEG SIZE", "LENGTH OPTION") reads LENGTH, matching the
  //    product option name
  //  - no "(cm)" inside the table; the unit is always one small grey note under the last table
  //    (the page's own "Garment measurements in cm" line, otherwise "Measurements in cm":
  //    every VE SAV chart is in cm)
  //  - unlabeled rows get their measurement name (hat: HEAD; shoes' "CM" row: FOOT LENGTH)
  //  - LENGH / LENGHT read LENGTH; empty paragraphs (extra space) are dropped
  function tidySizeChart(body) {
    var tables = Array.prototype.slice.call(body.querySelectorAll('table'));
    if (!tables.length) return;

    Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (p) {
      if (!p.textContent.trim() && !p.querySelector('img')) p.remove();
    });

    tables.forEach(function (table) {
      var rows = Array.prototype.slice.call(table.rows);
      var isHat = false;
      rows.forEach(function (row, r) {
        Array.prototype.slice.call(row.cells).forEach(function (cell, c) {
          var text = cell.textContent.replace(/\s+/g, ' ').trim();
          var clean = text.replace(/\s*\(cm\)/ig, '');
          clean = clean.replace(/\bLENGH?T?\b/g, 'LENGTH');
          if (c === 0 && r === 0) {
            if (/hat/i.test(clean)) isHat = true;
            if (!clean || /sizing chart/i.test(clean)) clean = 'SIZE';
            if (/^(leg size|length option)$/i.test(clean)) clean = 'LENGTH';
          } else if (c === 0) {
            if (!clean && isHat) clean = 'HEAD';
            if (/^cm$/i.test(clean)) clean = 'FOOT LENGTH';
          }
          if (clean !== text) cell.textContent = clean;
        });
      });
    });

    var last = tables[tables.length - 1];
    var note = null;
    Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (p) {
      var text = p.textContent.trim();
      if (!note && text.length < 60 && /\bcm\b|measurement/i.test(text) && !p.querySelector('img, table')) {
        note = p;
      }
    });
    if (!note) {
      note = document.createElement('p');
      note.textContent = 'Measurements in cm';
    }
    note.classList.add('vs-help__note');
    last.insertAdjacentElement('afterend', note);
  }

  // Product page: shipping note under Add to bag, and "Shipping & returns" and
  // "Need help?" links stacked after all product info, each opening a side panel.
  // Product accordions (e.g. Size guide) also become a link + panel here;
  // ve-sav-pdp.js then moves Size guide to right under the Add to bag button.
  function initProductPanels() {
    var info = document.querySelector('.product__info-container');
    var linksTemplate = document.getElementById('vs-help-trigger');
    if (!info || !linksTemplate || document.querySelector('.vs-help-trigger')) return;

    var noteTemplate = document.getElementById('vs-ship-note');
    var productForm = info.querySelector('product-form');
    if (noteTemplate && productForm) {
      productForm.insertAdjacentElement('afterend', noteTemplate.content.firstElementChild.cloneNode(true));
    }

    var links = linksTemplate.content.firstElementChild.cloneNode(true);
    info.appendChild(links);

    // Product accordions (e.g. Size guide) become links + panels at the top of the list
    var existingClose = document.querySelector('.vs-help .vs-panel__close');
    var closeLabel = (existingClose && existingClose.getAttribute('aria-label')) || 'Close';
    var firstLink = links.firstElementChild;
    info.querySelectorAll('.product__accordion').forEach(function (accordion, index) {
      var title = accordion.querySelector('.accordion__title');
      var content = accordion.querySelector('.accordion__content');
      if (!title || !content) return;

      var label = title.textContent.trim().toLowerCase();
      label = label.charAt(0).toUpperCase() + label.slice(1);
      // One name for every size chart link and panel
      if (/^size (guide|chart)$/i.test(label)) label = 'Size guide';
      var id = 'vs-accordion-' + index;

      var panel = document.createElement('div');
      panel.id = id;
      panel.className = 'vs-help';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', label);
      panel.hidden = true;
      panel.innerHTML =
        '<div class="vs-help__overlay" data-vs-help-close></div>' +
        '<div class="vs-help__panel" tabindex="-1">' +
        '<div class="vs-panel__head"><span></span>' +
        '<button type="button" class="vs-panel__close" data-vs-help-close></button></div>' +
        '<div class="vs-help__body"></div></div>';
      panel.querySelector('.vs-panel__head span').textContent = label;
      panel.querySelector('.vs-panel__close').setAttribute('aria-label', closeLabel);
      panel.querySelector('.vs-help__body').innerHTML = content.innerHTML;
      tidySizeChart(panel.querySelector('.vs-help__body'));
      document.body.appendChild(panel);

      var opener = document.createElement('button');
      opener.type = 'button';
      opener.className = 'vs-help-open';
      opener.dataset.vsPanel = id;
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', id);
      opener.textContent = label;
      links.insertBefore(opener, firstLink);

      accordion.remove();
    });

    var openPanel = null;
    var lastFocus = null;

    function close() {
      if (!openPanel) return;
      openPanel.hidden = true;
      openPanel = null;
      document.documentElement.classList.remove('vs-help-is-open');
      if (lastFocus) lastFocus.focus();
    }

    info.querySelectorAll('[data-vs-panel]').forEach(function (opener) {
      var panel = document.getElementById(opener.dataset.vsPanel);
      if (!panel) return;
      opener.addEventListener('click', function () {
        lastFocus = opener;
        panel.hidden = false;
        openPanel = panel;
        document.documentElement.classList.add('vs-help-is-open');
        panel.querySelector('.vs-help__panel').focus();
      });
    });

    document.querySelectorAll('.vs-help [data-vs-help-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  // Instagram row is a native scroll strip (see ve-sav-ui.css), so the arrows
  // scroll it by one post instead of running Instafeed's own slider.
  document.addEventListener(
    'click',
    function (event) {
      var arrow = event.target.closest && event.target.closest('#insta-feed .instafeed-new-arrow');
      if (!arrow) return;
      var row = arrow.closest('.instafeed-new-layout-container');
      var post = row && row.querySelector('.instafeed-new-layout-item');
      if (!post) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var direction = arrow.classList.contains('instafeed-new-arrow-prev') ? -1 : 1;
      row.scrollBy({ left: direction * (post.offsetWidth + 2), behavior: 'smooth' });
    },
    true
  );

  // Instagram posts open on Instagram (new tab) instead of Instafeed's pop-up
  function openInstagramPost(event) {
    var item = event.target.closest && event.target.closest('#insta-feed .instafeed-new-layout-item');
    var link = item && item.querySelector('a[href]');
    if (!link) return;
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.open(link.href, '_blank', 'noopener');
  }

  document.addEventListener('click', openInstagramPost, true);
  document.addEventListener('keydown', openInstagramPost, true);

  // Product pages: the Instafeed app block brings its own title; replace it with
  // the same heading used above the homepage feed (a link to the Instagram profile),
  // keeping the title text set in the app block
  function useInstagramHandle() {
    var profile = document.querySelector('.footer a[href*="instagram.com"]');
    document.querySelectorAll('#insta-feed > h2').forEach(function (title) {
      var feed = title.parentElement;
      if (!profile || (feed.previousElementSibling && feed.previousElementSibling.classList.contains('vs-insta-head'))) {
        return;
      }
      var handle = profile.href.replace(/\/+$/, '').split('/').pop();
      var text = title.textContent.trim() || '@' + handle;
      var head = document.createElement('div');
      head.className = 'vs-insta-head';
      var link = document.createElement('a');
      link.href = profile.href;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = text;
      head.appendChild(link);
      feed.parentElement.insertBefore(head, feed);
      title.remove();
    });
  }

  function init() {
    revealActiveCollection();
    useInstagramHandle();
    document.querySelectorAll('#insta-feed').forEach(function (feed) {
      if (feed.dataset.vsWatched) return;
      feed.dataset.vsWatched = '1';
      new MutationObserver(useInstagramHandle).observe(feed, { childList: true });
    });
    initProductPanels();
    document.querySelectorAll('media-gallery .slider-counter').forEach(function (counter) {
      if (counter.dataset.vsInit) return;
      counter.dataset.vsInit = '1';
      sync(counter);
      new MutationObserver(function () {
        sync(counter);
      }).observe(counter, { subtree: true, childList: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
